<template>
    <v-container flex grid-list-lg>
        <v-layout row wrap>
            <v-flex xs12>
                <v-toolbar color="#eee" class="elevation-0 secondary--text">
                    <v-toolbar-title>Configurações</v-toolbar-title>
                </v-toolbar>
            </v-flex>
            <v-flex xs12>
                <v-btn block large class="mb-3" @click="dialogSmsCheck = true">
                    <v-icon class="mr-2 material-icons">password</v-icon>
                    Cadastrar SmartLock
                </v-btn>
                <v-btn color="primary" :disabled="!smartLock" block large class="mb-3" @click="dialogLimite = true">
                    <v-icon class="mr-2">do_not_disturb_alt</v-icon>
                    Limite de compra
                </v-btn>
                <v-btn block large :disabled="!smartLock" color="secondary" class="mb-3" @click="dialogVersao = true">
                    <v-icon class="mr-2">private_connectivity</v-icon>
                    Bloquear versão do APP
                </v-btn>
                <v-btn :disabled="!smartLock" block large color="info" class="mb-3" @click="autenticacaoPorSms">
                    <v-icon class="mr-2">key</v-icon>
                    {{ pessoa && pessoa.autenticacao ? 'Desativar trava de segurança' : 'Ativar trava de segurança' }}
                </v-btn>
                <v-btn disabled color="error" block large class="mb-3">
                    <v-icon class="mr-2">pan_tool</v-icon>
                    Parar Smartlock
                </v-btn>
                <v-btn disabled block large class="mb-3">
                    <v-icon class="mr-2">computer</v-icon>
                    Dispositivos Permitidos
                </v-btn>
                <v-btn disabled block large class="mb-3">
                    <v-icon class="mr-2">dark_mode</v-icon>
                    Modo Escuro
                </v-btn>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          block
                          large
                          :disabled="!smartLock"
                          @click="dialogWhatsapp = true"
                          color="success"
                          class="mb-3"
                          v-bind="attrs"
                          v-on="on"
                      >
                          <v-icon class="mr-2">whatsapp</v-icon>
                          Mensagens whatsapp
                      </v-btn>
                  </template>
                  <h3>Configurações de Envio SendZapi</h3>
              </v-tooltip>
              <v-btn :disabled="!smartLock" block large class="mb-3 white--text" color="orange" @click="dialogTaxas = true">
                    <v-icon class="mr-2 material-icons">attach_money</v-icon>
                    Configurar taxas Checktudo
                </v-btn>
            </v-flex>
        </v-layout>
        <v-dialog
            width="600"
            :fullscreen="$vuetify.breakpoint.xs"
            lazy
            persistent
            v-model="dialogSmsCheck"
        >
            <sms-check @fechar="dialogSmsCheck = false" @callDialog="dialogCadSmartLock = true"/>
        </v-dialog>
        <v-dialog
            width="600"
            :fullscreen="$vuetify.breakpoint.xs"
            lazy
            persistent
            v-model="dialogCadSmartLock"
            >
            <cad-smart-lock @fechar="dialogCadSmartLock = false"/>
    </v-dialog>
    <v-dialog v-model="dialogLimite" v-if="dialogLimite" width="700" scrollable>
        <dialog-limite-compra @error="showError" @success="showSuccess"  @fechar="dialogLimite = false"/>
    </v-dialog>
    <v-dialog v-model="dialogVersao" v-if="dialogVersao" width="700" scrollable>
        <dialog-editar-versao-app @error="showError" @success="showSuccess"  @fechar="dialogVersao = false"/>
    </v-dialog>
    <v-dialog v-model="dialogWhatsapp" v-if="dialogWhatsapp" width="50em">
      <dialog-send-zapi @fechar="dialogWhatsapp = false"/>
    </v-dialog>
    <v-dialog v-model="dialogTaxas" v-if="dialogTaxas" width="700">
        <dialog-taxas-checktudo @error="showError" @success="showSuccess"  @fechar="dialogTaxas = false"/>
    </v-dialog>
    <v-snackbar
        v-model="snackbar.active"
        :color="snackbar.color"
        :multi-line="snackbar.multiLine"
        :timeout="snackbar.timeout"
        :vertical="snackbar.vertical"
      >
        {{ snackbar.text }}
        <v-btn
          flat
          @click="snackbar.active = false"
        >
          Fechar
        </v-btn>
      </v-snackbar>
    </v-container>
</template>
<script>
import SmsCheck from '@/components/dialogs/SmsCheck'
import CadSmartLock from '@/components/cadastros/CadSmartLock'
import DialogLimiteCompra from '@/components/dialogs/DialogLimiteCompra'
import DialogEditarVersaoApp from '@/components/dialogs/EditarVersaoApp'
import DialogSendZapi from '@/components/dialogs/SendZapi.vue'
import DialogTaxasChecktudo from '@/components/dialogs/TaxasChecktudo.vue'

export default {
  components: {
    SmsCheck,
    CadSmartLock,
    DialogLimiteCompra,
    DialogEditarVersaoApp,
    DialogSendZapi,
    DialogTaxasChecktudo
  },
  data () {
    return {
      dialogSmsCheck: false,
      dialogCadSmartLock: false,
      dialogLimite: false,
      dialogVersao: false,
      dialogWhatsapp: false,
      dialogTaxas: false,
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      }
    }
  },
  computed: {
    pessoa () {
      return this.$store.getters.pessoa
    },
    smartLock () {
      return this.$store.getters.smartLock
    }
  },
  methods: {
    showSuccess (info) {
      this.snackbar.color = 'primary'
      this.snackbar.text = info
      this.snackbar.active = true
    },
    showError (error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    },
    autenticacaoPorSms () {
      this.$store
      .dispatch('updatePessoa', {
        id_pessoa: this.pessoa.id_pessoa,
        autenticacao: !this.pessoa.autenticacao
      }).then(() => {
        this.showSuccess(this.pessoa.autenticacao ? 'Autenticação por SMS desativada com sucesso' : 'Autenticação por SMS ativada com sucesso')
        this.$store.dispatch('carregarPerfil')
      }).catch(() => {
        this.showError('Não foi possível atualizar as informações de sistema do usuário.')
      })
    }
  },
  mounted () {
      if (!this.pessoa) {
        this.$store.dispatch('carregarPerfil')
      }
  }
}
</script>
<style scoped>
.lista {
    color: gray;
    cursor: pointer;
}
.lista:hover{
    color: black;
    background-color:rgba(189, 190, 189, 0.1);
}
</style>
